import api from '../api';
import icons from '../../../../shared/utils/files/antIcons';
import getMess from '../translations';
import { fileOwnerTypes } from '../../../../shared/constants/enums';

const label = 'createFolder';

function handler(apiOptions, actions) {
  const { showDialog, hideDialog, navigateToDir, setParentsForResource, getResource, rootContainer } = actions;

  const getMessage = getMess.bind(null, apiOptions.locale);

  const rawDialogElement = {
    elementType: 'CreateFolderDialog',
    elementProps: {
      onHide: hideDialog,
      rootContainer: rootContainer,
      onSubmit: async (folderName) => {
        const resource = getResource();
        const resourceChildren = await api.getChildrenForId(apiOptions, { id: resource.id, systemFolderType: resource.systemFolderType });
        const alreadyExists = resourceChildren.some(({ name }) => name === folderName);

        if (alreadyExists) {
          return getMessage('fileExist', { name: folderName });
        } else {
          hideDialog();
          const result = await api.createFolder(apiOptions, resource.id, folderName);

          if (result) {
            navigateToDir(resource.id, result.data.id);
            setParentsForResource(resource.id);
          }
        }

        return null;
      },
    },
  };

  showDialog(rawDialogElement);
}

export default (apiOptions, actions) => {
  const localeLabel = getMess(apiOptions.locale, label);
  const { getResource, ownerType } = actions;
  return {
    id: label,
    icon: { icon: icons.createNewFolder },
    label: localeLabel,
    shouldBeAvailable: (apiOptions) => {
      const resource = getResource();

      if (!resource || !resource.capabilities) {
        return false;
      }

      if (
        +ownerType === fileOwnerTypes.InsuredDefaultFolderStructure ||
        +ownerType === fileOwnerTypes.PolicyDefaultFolderStructure ||
        +resource.systemFolderType === 5 /*InsuredDefaultFiles*/ ||
        +resource.systemFolderType === 6 /*PolicyDefaultFiles*/
      ) {
        return true;
      }

      return resource.capabilities.canAddChildren;
    },
    availableInContexts: ['files-view', 'new-button'],
    handler: () => handler(apiOptions, actions),
  };
};
